import React from "react";
import Section from "../Section";
import EyeIconSVG from "../SVG/EyeIconSVG";
import { CgSearchLoading } from "react-icons/cg";
import { Link, useNavigate } from "react-router-dom";
import { delayNavigation } from "../../helpers/helpers";
import { useDispatch } from "react-redux";

const SearchSection = ({ project }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <Section bg="bg-inherit">
      <div className="col-span-full grid grid-cols-2 xl:grid-cols-12 gap-16 py-16 px-8 xl:px-0">
        <Link
          to={`/projects/${project}/block`}
          onClick={(event) => {
            delayNavigation(
              dispatch,
              navigate,
              `/projects/${project}/block`,
              event
            );
          }}
          className="py-10 md:py-20 xl:py-32 col-span-1 xl:col-span-5 xl:col-start-2  flex flex-col items-center justify-center rounded-3xl bg-primary-bg-green xl:bg-primary-bg-green/25 hover:bg-primary-bg-green transform duration-300 ease-linear text-primary-light xl:text-primary-dark xl:text-3xl tracking-wide hover:text-primary-light hover:text-2xl cursor-pointer "
        >
          <EyeIconSVG h={40} w={40} />
          <h2 className="mt-4 text-center">ვიზუალური ნავიგაცია</h2>
        </Link>
        <Link
          to={`/projects/${project}/apartments`}
          onClick={(event) => {
            delayNavigation(
              dispatch,
              navigate,
              `/projects/${project}/apartments`,
              event
            );
          }}
          className="py-10 md:py-20 xl:py-32 col-span-1 xl:col-span-5 flex flex-col items-center justify-center rounded-3xl bg-primary-orange xl:bg-primary-orange/25 hover:bg-primary-orange transform duration-300 ease-linear text-primary-light xl:text-primary-dark xl:text-3xl tracking-wide hover:text-primary-light cursor-pointer "
        >
          <CgSearchLoading className=" w-12 h-12 " />
          <h2 className="mt-4 text-center">დეტალური ძებნა</h2>
        </Link>
      </div>
    </Section>
  );
};

export default SearchSection;
